export class ArrayBufferDestructor {
  /**
   * Splits an ArrayBuffer into multiple ArrayBuffers based on specified offsets.
   *
   * @param {ArrayBuffer} buffer - The ArrayBuffer to be split.
   * @param {number[]} offsets - An array of byte offsets to determine the split points within the buffer.
   * @return {ArrayBuffer[]} An array of ArrayBuffers obtained after splitting the input buffer.
   * @throws {Error} If any offset exceeds the buffer length.
   */
  public static destructArrayBuffer(buffer: ArrayBuffer, offsets: number[]): ArrayBuffer[] {
    const result: ArrayBuffer[] = [];
    let previousOffset = 0;

    for (const offset of offsets) {
      if (offset > buffer.byteLength) {
        throw new Error('Offset exceeds buffer length');
      }
      const slice = buffer.slice(previousOffset, previousOffset + offset);
      result.push(slice);
      previousOffset = previousOffset + offset;
    }

    if (previousOffset < buffer.byteLength) {
      result.push(buffer.slice(previousOffset));
    }

    return result;
  }
}
